// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"8878978a","213":"6a411109","455":"d2c82b60","834":"839e960a"}[chunkId] + ".chunk.js";
};